import ky from "ky"
import { CORE_API_ENDPOINT } from "@/constants"
import { useCourseStore } from "@/store/courseStoreProvider"
import { useMemo } from "react"

export const headers = {
  "strict-transport-security": `max-age=63072000; includeSubdomains; preload`,
  "x-content-type-options": `nosniff`,
  "x-frame-options": `DENY`,
  "x-xss-protection": `1; mode=block`,
  "referrer-policy": `same-origin`,
  Accept: `application/json`,
  "Content-Type": `application/json`,
}

export function useRequest() {
  const { CORE_API_ENDPOINT } = useCourseStore((s) => s.envVars)
  const client = useMemo(
    () =>
      ky.create({
        headers,
        prefixUrl: CORE_API_ENDPOINT,
        credentials: "include",
      }),
    [CORE_API_ENDPOINT],
  )

  return client
}

const client = ky.create({
  headers,
  prefixUrl: CORE_API_ENDPOINT,
  credentials: "include",
})

const externalClient = client.extend({ prefixUrl: "" })

export { client as request, externalClient as externalRequest }
